<template>
<v-app>
  <div>
    <v-btn color="info" v-on:click="gotoUsers">Usuarios</v-btn>
    <v-btn color="info" v-on:click="gotoNews">Noticias</v-btn>
    <v-btn color="info" v-on:click="gotoComments">Sugerencias</v-btn>
    <v-btn color="info" v-on:click="gotoShops">Locales</v-btn>
    <v-btn color="error" v-on:click="logout">Salir</v-btn>
    <img src="../assets/logo.png" width="100px" style="float: right;">
    <hr style="margin-bottom: 50px;">

    <v-dialog v-model="dialog" persistent max-width="600px">
      <v-card>
        <v-card-text>
          <v-container grid-list-md>
            <v-form id="theForm" @submit.prevent="addArticle(title, desc, content, image, image_mini, published)">
                <div class="title" v-if="!isEdition">Crear Noticia</div>
                <div class="title" v-if="isEdition">Editar Noticia</div>

                <v-switch
                    v-model="published"
                    :label="`Noticia Publicada`"
                ></v-switch>

                <v-flex>
                    <v-text-field
                        label="Título"
                        box
                        v-model="title"
                        required
                    ></v-text-field>
                </v-flex>

                <v-flex>
                    <v-text-field
                        label="Breve descripción"
                        box
                        v-model="desc"
                        required
                    ></v-text-field>
                </v-flex>

                <v-flex>
                    <v-textarea
                        box
                        label="Contenido"
                        v-model="content"
                        required
                    ></v-textarea>
                </v-flex>

                <div class="subheading">Imagen Grande</div>
                <div>
                    <v-btn @click.native="selectFile" v-if="!uploadEnd && !uploading">
                        Subir Foto
                        <v-icon right aria-hidden="true">
                            add_a_photo
                        </v-icon>
                    </v-btn>
                    <input id="files" type="file" name="file" ref="uploadInput" accept="image/*" :multiple="false" @change="detectFiles($event)" />
                    <v-progress-circular v-if="uploading && !uploadEnd"
                        :rotate="-90"
                        :size="100"
                        :width="15"
                        :value="progressUpload"
                        color="primary">
                        {{ progressUpload }}%
                    </v-progress-circular>
                    <img v-if="uploadEnd" :src="downloadURL" width="40%" />
                    <div v-if="uploadEnd">
                        <v-btn class="ma-0" dark small color="error" @click="deleteImage()">
                            Eliminar Imagen Grande
                        </v-btn>
                    </div>
                </div>

                <div class="subheading" style="margin-top: 15px;">Imagen Chica</div>
                <div>
                    <v-btn @click.native="selectFileC" v-if="!uploadEndC && !uploadingC">
                        Subir Foto
                        <v-icon right aria-hidden="true">
                            add_a_photo
                        </v-icon>
                    </v-btn>
                    <input id="files" type="file" name="file" ref="uploadInputC" accept="image/*" :multiple="false" @change="detectFilesC($event)" />
                    <v-progress-circular v-if="uploadingC && !uploadEndC"
                        :rotate="-90"
                        :size="100"
                        :width="15"
                        :value="progressUploadC"
                        color="primary">
                        {{ progressUploadC }}%
                    </v-progress-circular>
                    <img v-if="uploadEndC" :src="downloadURLC" width="40%" />
                    <div v-if="uploadEndC">
                        <v-btn class="ma-0" dark small color="error" @click="deleteImageC()">
                            Eliminar Imagen Chica
                        </v-btn>
                    </div>
                </div>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn type="button" color="error" @click="clearForm()" style="margin-top: 15px;">Cancelar</v-btn>
          <v-btn type="submit" color="primary" form="theForm" style="margin-top: 15px;">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <div class="display-2" style="margin-bottom: 10px;">
        Noticias

        <v-btn
            fab
            color="primary"
            right
            absolute
            @click="dialog = !dialog"
            >
            <v-icon>add</v-icon>
        </v-btn>
    </div>

    <table width="100%" style="margin-top: 50px;">
        <thead class="title">
            <th style="text-align: left;">Título</th>
            <th style="text-align: left;">Creación</th>
            <th style="text-align: left;">Estado</th>
            <th style="text-align: right;">Acciones</th>
        </thead>
        <tr v-for="(article, idx) in news" :key="idx">
            <td style="text-align: left;">{{ article.title }}</td>
            <td style="text-align: left;">{{ article.createdAtStr }}</td>
            <td style="text-align: left;">{{ article.published ? 'Publicada' : 'Oculta' }}</td>
            <td style="text-align: right;">
                <v-btn fab small color="primary" @click="startItemEdit(article.id)">
                    <v-icon>edit</v-icon>
                </v-btn>
                <v-btn fab small color="error" @click="deleteArticle(article.id)">
                    <v-icon>delete</v-icon>
                </v-btn>
            </td>
        </tr>
        <tr>
            <td style="text-align: left;"></td>
            <td style="text-align: right;" colspan="3">
                <v-btn color="success" @click="getArticles()">
                    Cargar mas items
                    <v-icon right>cloud_download</v-icon>
                </v-btn>
            </td>
        </tr>
    </table>
  </div>
</v-app>
</template>

<script>
import Vue from 'vue';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
Vue.use(Loading);

import firebase from 'firebase'
import { db, storage } from '../main'

export default {
    name: 'News',
    data () {
        return {
            dialog: false,
            news: [],
            isEdition: false,
            itemID: '',
            title: '',
            desc: '',
            content: '',
            image: '',
            image_mini: '',
            published: false,
            lastListDoc: null,
            loaderPrefs: {
                'container': null,
                'canCancel': false,
                'color': '#0000FF',
                'background-color': '#FFCC99',
            },
            progressUpload: 0,
            fileName: '',
            uploadTask: '',
            uploading: false,
            uploadEnd: false,
            downloadURL: '',
            progressUploadC: 0,
            fileNameC: '',
            uploadTaskC: '',
            uploadingC: false,
            uploadEndC: false,
            downloadURLC: ''
        }
    },
    methods: {
        getArticles (auto) {
            let loader = this.$loading.show(this.loaderPrefs);
            var vm = this;
            var query;

            if (vm.lastListDoc) {
                console.log("lastListDoc", vm.lastListDoc);
                query = db.collection("news")
                    .orderBy("createdAt", "desc")
                    .startAfter(vm.lastListDoc)
                    .limit(10);
            } else {
                console.log("No lastListDoc");
                query = db.collection("news")
                    .orderBy("createdAt", "desc")
                    .limit(10);
            }

            query.get()
                .then(function(res) {
                    console.log("Received: " + res.docs.length);

                    res.forEach(doc => {
                        let item = doc.data();
                        item.id = doc.id;
                        item.createdAtStr = vm.formatDate(item.createdAt.toDate());
                        vm.news.push(item);

                        vm.lastListDoc = doc;
                    });

                    if (res.docs.length == 0 && auto !== true) {
                        alert("No hay más noticias!");
                    }

                    loader.hide();
            })
            .catch(function(error) {
                console.error("Error getting article list: ", error);
                loader.hide();
            });
        },
        addArticle (title, desc, content, image, image_mini, published) {
            let loader = this.$loading.show(this.loaderPrefs);
            var vm = this;

            let item = {
                'title': title,
                'desc': desc,
                'content': content,
                'image': image,
                'image_mini': image_mini,
                'published': published,
            }

            if (!this.isEdition) {
                item.createdAt = new Date();

                db.collection('news')
                    .add(item)
                    .then(function(obj) {
                        console.log(obj)
                        item.id = obj.id;

                        // Keep counters updated
                        // let actCount = (published) ? 1 : 0;
                        // db.collection('_counters')
                        //     .doc('news')
                        //     .update({
                        //         total: firebase.firestore.FieldValue.increment(1), 
                        //         active: firebase.firestore.FieldValue.increment(actCount)
                        //     });

                        // Keep already cached items updated
                        vm.news.unshift(item);
                        vm.clearForm();
                        loader.hide();
                    })
                    .catch(function(err) {
                        console.log(err)
                        loader.hide();
                    });
            } else {
                item.modifiedAt = new Date();
                var itemRef = db.collection("news").doc(this.itemID);

                itemRef
                    .update(item)
                    .then(function() {
                        console.log("Document successfully updated!");
                        
                        var idx = -1;
                        for (var i=0; i<vm.news.length; i++) {
                            if (vm.itemID == vm.news[i].id) {
                                idx = i;
                                break;
                            }
                        }

                        // Keep counters updated
                        // let actCount = 0;
                        // if (vm.news[idx].published && !item.published) {
                        //     actCount = -1;
                        // }
                        // if (!vm.news[idx].published && item.published) {
                        //     actCount = 1;
                        // }
                        // db.collection('_counters')
                        //     .doc('news')
                        //     .update({
                        //         active: firebase.firestore.FieldValue.increment(actCount)
                        //     });

                        // Keep already cached items updated
                        if (idx > -1) {
                            vm.news[idx].title = item.title;
                            vm.news[idx].desc = item.desc;
                            vm.news[idx].content = item.content;
                            vm.news[idx].image = item.image;
                            vm.news[idx].image_mini = item.image_mini;
                            vm.news[idx].published = item.published;
                        }
                        
                        vm.clearForm();
                        loader.hide();
                    })
                    .catch(function(error) {
                        console.error("Error updating document: ", error);
                        loader.hide();
                    });
            }
        },
        deleteArticle (id) {
            if (confirm("Eliminar la noticia?")) {
                let loader = this.$loading.show(this.loaderPrefs);
                var vm = this;

                db.collection('news').doc(id)
                    .delete()
                    .then(function() {
                        var idx = -1;
                        for (var i=0; i<vm.news.length; i++) {
                            if (id == vm.news[i].id) {
                                idx = i;
                                break;
                            }
                        }

                        // Keep counters updated
                        // let actCount = 0;
                        // if (vm.news[idx].published) {
                        //     actCount = -1;
                        // }
                        // db.collection('_counters')
                        //     .doc('news')
                        //     .update({
                        //         total: firebase.firestore.FieldValue.increment(-1), 
                        //         active: firebase.firestore.FieldValue.increment(actCount)
                        //     });

                        // Keep already cached items updated
                        if (idx > -1) {
                            vm.news.splice(i, 1);
                        }

                        loader.hide();
                    })
                    .catch(function(error) {
                        console.error("Error updating document: ", error);
                        loader.hide();
                    });
            }
        },
        startItemEdit (id) {
            var vm = this;

            var idx = -1;
            for (var i=0; i<vm.news.length; i++) {
                if (id == vm.news[i].id) {
                    idx = i;
                    break;
                }
            }

            if (idx > -1) {
                this.isEdition = true;
                this.itemID = vm.news[idx].id;
                this.title = vm.news[idx].title;
                this.desc = vm.news[idx].desc;
                this.content = vm.news[idx].content;
                this.image = vm.news[idx].image;
                this.downloadURL = vm.news[idx].image;
                this.uploadEnd = !(!(vm.news[idx].image));
                this.image_mini = vm.news[idx].image_mini;
                this.downloadURLC = vm.news[idx].image_mini;
                this.uploadEndC = !(!(vm.news[idx].image_mini));
                this.published = vm.news[idx].published;
            }

            this.dialog = true;
        },
        clearForm () {
            this.dialog = false;

            // Clear values
            this.isEdition = false
            this.itemID = ''
            this.title = ''
            this.desc = ''
            this.content = ''
            this.image = ''
            this.downloadURL = ''
            this.uploading = false
            this.uploadEnd = false
            this.image_mini = ''
            this.downloadURLC = ''
            this.uploadingC = false
            this.uploadEndC = false
            this.published = false
        },
        selectFile () {
            this.$refs.uploadInput.click()
        },
        selectFileC () {
            this.$refs.uploadInputC.click()
        },
        detectFiles (e) {
            let fileList = e.target.files || e.dataTransfer.files
            Array.from(Array(fileList.length).keys()).map(x => {
                this.upload(fileList[x])
            })
        },
        detectFilesC (e) {
            let fileList = e.target.files || e.dataTransfer.files
            Array.from(Array(fileList.length).keys()).map(x => {
                this.uploadC(fileList[x])
            })
        },
        upload (file) {
            this.fileName = file.name
            this.uploading = true
            this.uploadTask = storage.ref('images/' + file.name).put(file)
        },
        uploadC (file) {
            this.fileNameC = file.name
            this.uploadingC = true
            this.uploadTaskC = storage.ref('images/' + file.name).put(file)
        },
        deleteImage () {
            storage
            .ref('images/' + this.fileName)
            .delete()
            .then(() => {
                this.uploading = false
                this.uploadEnd = false
                this.downloadURL = ''
                this.image = ''
            })
            .catch((error) => {
                console.error(`file delete error occured: ${error}`)
            });
        },
        deleteImageC () {
            storage
            .ref('images/' + this.fileName)
            .delete()
            .then(() => {
                this.uploadingC = false
                this.uploadEndC = false
                this.downloadURLC = ''
                this.image_mini = ''
            })
            .catch((error) => {
                console.error(`file delete error occured: ${error}`)
            });
        },
        gotoUsers () {
            this.$router.replace('users');
        },
        gotoNews () {
            this.$router.replace('news');
        },
        gotoComments () {
            this.$router.replace('comments');
        },
        gotoShops () {
            this.$router.replace('shops');
        },
        logout () {
            firebase.auth().signOut().then(() => {
                this.$router.replace('login')
            })
        },
        formatDate(d, format, fsep, msep, hsep) {
            if (!d) return "";

            if (!format) format = 'DD/MM/YYYY HH:MM'; 
            if (fsep === undefined) fsep = '/'; 
            if (msep === undefined) msep = ' '; 
            if (hsep === undefined) hsep = ':'; 

            let m = (d.getMonth() + 1);
            if (m < 10) {
                m = "0" + m;
            }

            let mi = d.getMinutes();
            if (mi < 10) {
                mi = "0" + mi;
            }

            if (format == 'YYYYMMDDHHMI') {
                return d.getFullYear() + fsep + m + fsep + d.getDate() + msep + d.getHours() + hsep + mi;
            } else {
                return d.getDate() + fsep + m + fsep + d.getFullYear() + msep + d.getHours() + hsep + mi;
            }
        }
    },
    mounted: function () {
        var vm = this;
        this.$nextTick(function () {
            vm.getArticles(true);
        })
    },
    watch: {
        uploadTask: function () {
            this.uploadTask.on('state_changed', sp => {
                this.progressUpload = Math.floor(sp.bytesTransferred / sp.totalBytes * 100)
            },
            null,
            () => {
                this.uploadTask.snapshot.ref.getDownloadURL().then(downloadURL => {
                    this.uploadEnd = true
                    this.downloadURL = downloadURL
                    this.image = downloadURL
                    this.$emit('downloadURL', downloadURL)
                })
            })
        },
        uploadTaskC: function () {
            this.uploadTaskC.on('state_changed', sp => {
                this.progressUploadC = Math.floor(sp.bytesTransferred / sp.totalBytes * 100)
            },
            null,
            () => {
                this.uploadTaskC.snapshot.ref.getDownloadURL().then(downloadURL => {
                    this.uploadEndC = true
                    this.downloadURLC = downloadURL
                    this.image_mini = downloadURL
                    this.$emit('downloadURL', downloadURL)
                })
            })
        }
    }
}
</script>

<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: black;
}
.formLabel {
  font-size: 12px;
  font-weight: bold;
}
.logout {
  left: 50%;
  top: 100%;
}
.progress-bar {
  margin: 10px 0;
}
input[type="file"] {
  position: absolute;
  clip: rect(0,0,0,0);
}
</style>


// WEBPACK FOOTER //
// src/components/News.vue